module.exports = __webpack_public_path__ + "img/folder.5f21613b.svg";